import { CrudStoreItemPartner360 } from 'legacy/lut/classes/models/partner360/CrudStoreItemPartner360'
import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { callProcedureJBPCommitmentDataInit } from 'legacy/lut/components/widgets/public/partner360/programTypeButtons/components/programTypesEditor/components/programTypesEditorModal/api/callProcedureJBPCommitmentDataInit'

import { Logic, Operator } from 'core-components/types'
import { CrudStore } from 'core/types/crudStore'

interface ISwitchOfferingArgs {
  partnerId: string
  programType: ProgramTypes
  fYear: number
  enabled: boolean
}
export const switchOffering = async ({
  partnerId,
  programType,
  fYear,
  enabled,
}: ISwitchOfferingArgs) => {
  const crud = CrudStore.get(CrudStoreItemPartner360.ExceptionalPartnerSpecialization)
  crud.setFilter({
    logic: Logic.AND,
    filters: [
      {
        field: 'PartnerId',
        operator: Operator.EQUAL,
        value: partnerId,
      },
      {
        field: 'ProgramType',
        operator: Operator.EQUAL,
        value: programType,
      },
      {
        field: 'FYear',
        operator: Operator.EQUAL,
        value: fYear,
      },
    ],
  })
  const response = await crud.fetch()
  if (response && response.items && response.items.length) {
    await crud.update(
      {
        formId: '766',
        code: 'JBPExceptionalPartnerSpecialization',
      },
      [
        {
          EntryId: response.items[0].EntryId,
          PartnerId: partnerId,
          ProgramType: programType,
          FYear: fYear,
          Enabled: enabled,
        },
      ]
    )
    if (enabled) {
      await callProcedureJBPCommitmentDataInit({
        partnerId,
        programType: programType,
        fYear,
      })
    }
  } else {
    // TODO: this should be checked, but looks like this condition never called. and whole if statement is redundant. it should be enough just `crud.update`
    await crud.create(
      {
        formId: '766',
        code: 'JBPExceptionalPartnerSpecialization',
      },
      [
        {
          PartnerId: partnerId,
          ProgramType: programType,
          FYear: fYear,
          Enabled: enabled,
        },
      ]
    )
  }
}
